import { render } from "./disclaimer.vue?vue&type=template&id=0784fa6a&scoped=true"
import script from "./disclaimer.vue?vue&type=script&lang=js"
export * from "./disclaimer.vue?vue&type=script&lang=js"

import "./disclaimer.vue?vue&type=style&index=0&id=0784fa6a&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Yuegao\\vue_pro\\2003_yuebao_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0784fa6a"]])

export default __exports__